// extracted by mini-css-extract-plugin
export var borderRadius = "_5d-4";
export var large = "_5d-3";
export var logoContainer = "_5d-0";
export var nameLogo = "_5d-2";
export var small = "_5d-1";